import _findIndexInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find-index';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import React__default from 'react';
import { useUniqueId } from './useId.js';

/**
 * Props for the Progress Indicator component.
 */

/**
 * State of the stepper.
 */

/**
 * Hook to use Progress Indicator.
 */

var useProgressIndicator = function useProgressIndicator(_ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
    steps = _ref.steps;
  // IDs
  var progressIndicatorId = useUniqueId();
  var progressId = useUniqueId();
  var labelId = "".concat(useUniqueId(), "-label");

  // States & Ref's
  var currentStep = _findIndexInstanceProperty(steps).call(steps, function (el) {
    return el.progressionState === 'current';
  });
  var hasPreviousStep = React__default.useRef(false);
  var hasNextStep = React__default.useRef(false);
  var stepElementsRef = React__default.useRef([]);
  var totalSteps = React__default.useRef(steps.length);

  // Check previous step
  hasPreviousStep.current = currentStep > 0;

  // Check next step
  hasNextStep.current = currentStep < steps.length - 1;

  // Build the props for the Progress Indicator element.
  var progressIndicatorProps = React__default.useMemo(function () {
    return {
      role: 'tablist',
      'aria-orientation': direction
    };
  }, [direction]);

  // Build the props for each step element.
  var stepProps = React__default.useMemo(function () {
    return _mapInstanceProperty(steps).call(steps, function (step, index) {
      var _context;
      return {
        role: 'tab',
        tabIndex: step.progressionState === 'disabled' ? -1 : 0,
        id: _concatInstanceProperty(_context = "".concat(progressIndicatorId, "-")).call(_context, index),
        hasNextStep: steps.length - 1 !== index,
        'aria-posinset': index + 1,
        'aria-setsize': steps.length,
        'aria-disabled': step.progressionState === 'disabled',
        'aria-current': index === currentStep ? 'step' : undefined,
        'aria-selected': index === currentStep,
        ref: function ref(element) {
          if (element) {
            stepElementsRef.current[index] = element;
          }
        }
      };
    });
  }, [currentStep, progressIndicatorId, steps]);

  // Build the props for the progress bar element.
  var progressProps = React__default.useMemo(function () {
    return {
      'aria-valuenow': currentStep,
      'aria-valuemin': 0,
      'aria-valuemax': steps.length - 1,
      role: 'progressbar',
      'aria-labelledby': labelId,
      tabIndex: -1 // prevent focus
    };
  }, [currentStep, labelId, steps]);

  // Build the state of the progressIndicator.
  var state = React__default.useMemo(function () {
    return {
      labelId: labelId,
      progressId: progressId,
      currentStep: currentStep,
      hasPreviousStep: hasPreviousStep.current,
      hasNextStep: hasNextStep.current,
      totalSteps: totalSteps.current
    };
  }, [currentStep, labelId, progressId]);
  return {
    progressIndicatorProps: progressIndicatorProps,
    stepProps: stepProps,
    progressProps: progressProps,
    state: state
  };
};

export { useProgressIndicator };
//# sourceMappingURL=useProgressIndicator.js.map
